import { gql } from 'graphql-tag';

import { GQReportMode } from '../../generated/graphql-schema-types';

import flattenConnection from '@watershed/shared-universal/utils/flattenConnection';

import { useReportSummariesQuery } from '../../generated/urql';
import {
  WatershedProduct,
  useCurrentProductContext,
} from '../../utils/CurrentProductContext';

gql`
  fragment ReportSummary on Report {
    id
    name
    updatedAt
  }

  query ReportSummaries($reportMode: ReportMode!) @withOwner(owner: Reporting) {
    formalReports(last: 5, reportMode: $reportMode) {
      edges {
        node {
          ...ReportSummary
        }
      }
    }
  }
`;

export function useRecentReportSummaries() {
  const { currentProduct } = useCurrentProductContext();

  const [{ data, fetching: isLoading }] = useReportSummariesQuery({
    variables: {
      reportMode:
        currentProduct === WatershedProduct.Finance
          ? GQReportMode.Finance
          : GQReportMode.Corporate,
    },
    pause: currentProduct === WatershedProduct.Unknown,
  });

  const reports = flattenConnection(data?.formalReports) || [];
  // sorting is returned from the server
  const recentReports = reports.slice(0, 5);

  return { recentReports, isLoading };
}
